import { zurich_data } from './cities_de/zurich'
import { geneva_data } from './cities_de/geneva'
import { basel_data } from './cities_de/basel'
import { bern_data } from './cities_de/bern'
import { lausanne_data } from './cities_de/lausanne'

export const city_datas_de: { [key: string]: CityData } = {
  zurich: zurich_data,
  geneva: geneva_data,
  basel: basel_data,
  bern: bern_data,
  lausanne: lausanne_data,
}

export function getCityData_de(
  mob: boolean = false,
  dm: boolean = false,
  city: string = 'zurich'
): CityData {
  var desiredcity: CityData = city_datas_de[city]

  desiredcity.elements.forEach((el) => {
    el.image = require('../Maps/maps_' +
      desiredcity.bfsid +
      '_' +
      el.id +
      (mob ? '_mob' : '') +
      (dm ? '_dm' : '') +
      '.jpg')
  })
  return desiredcity
}
